// Generated by purs version 0.14.5
"use strict";
var hashchange = "hashchange";
module.exports = {
    hashchange: hashchange
};
